import styled from 'styled-components';
import { bodySmall } from '../paragraph';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DescriptionContainer = styled.span`
  font-weight: normal;
  color: ${({ theme }): string => theme.palette_gray_60};
  ${bodySmall}
`;

export const InputWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }): string => theme.spacing_unit_x1};
  border-width: 2px;
  border-style: solid;
  border-color: ${({ theme }): string => theme.palette_gray_5};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
  background-color: ${({ disabled, theme }): string =>
    disabled ? theme.palette_gray_5 : theme.palette_white};
`;

export const StyledInput = styled.input<{ disabled?: boolean }>`
  outline: none;
  border-color: transparent;
  flex-grow: 1;
  height: ${({ theme }): string => theme.spacing_unit_x4};
  background-color: ${({ disabled, theme }): string =>
    disabled ? theme.palette_gray_5 : theme.palette_white};
`;
